import type { JSX, ReactNode } from 'react';
import { Link } from 'react-router';
import type { EvenementCalendrier } from './periodes.js';

/**
 * L'événement comme cible de clic : un lien vers sa fiche, un bouton qui
 * l'ouvre (le rendez-vous), ou un simple texte quand rien ne l'ouvre.
 */
export function ElementEvenement({
  evenement,
  className,
  children,
  titre,
}: {
  evenement: EvenementCalendrier;
  className: string | undefined;
  children: ReactNode;
  /** Info-bulle : le titre complet quand le texte est tronqué. */
  titre?: string;
}): JSX.Element {
  if (evenement.href) {
    return (
      <Link className={className} to={evenement.href} title={titre}>
        {children}
      </Link>
    );
  }
  if (evenement.onSelect) {
    return (
      <button type="button" className={className} onClick={evenement.onSelect} title={titre}>
        {children}
      </button>
    );
  }
  return (
    <span className={className} title={titre}>
      {children}
    </span>
  );
}
